import { gql } from '@apollo/client';

export const SERVICE_FRAGMENT = gql`
  fragment Service on Service {
    id
    name
    cost
    description
    imagePath
    price
    point
    timeInMinutes
    isAvailable
    updatedAt
    createdAt
    pivot {
      outletId
      serviceId
      isAvailable
    }
    outletServiceStylists {
      id
      cost
      outletId
      outletServiceId
      point
      price
      regularPrice
      stylistId
    }
  }
`;
